import React from 'react';

/**
 * GLOW 푸터 배지 아이콘 영역 — HeaderTop 배지와 동일 규칙
 * (icon: 이모지 | ti-* | check), 구 데이터는 svg(React)·svgKey(award)·dot 폴백
 */
export function renderFooterGlowBadgeLeading(badge) {
  const wrap = (node, ...extra) => (
    <span className={['footer-glow-platform-badge-icon', ...extra.filter(Boolean)].join(' ')} aria-hidden="true">
      {node}
    </span>
  );

  const rawIcon = badge?.icon;
  if (rawIcon != null && String(rawIcon).trim() !== '') {
    const s = String(rawIcon).trim();
    if (s === 'check') return wrap(<i className="ti-check" />, 'footer-glow-platform-badge-icon--ti');
    if (s.startsWith('ti-')) return wrap(<i className={s} />, 'footer-glow-platform-badge-icon--ti');
    return wrap(<span className="footer-glow-platform-badge-emoji">{s}</span>);
  }
  if (badge?.svg) {
    return wrap(badge.svg, 'footer-glow-platform-badge-icon--svg');
  }
  if (badge?.svgKey === 'award') {
    return wrap(<i className="ti-world" />, 'footer-glow-platform-badge-icon--ti');
  }
  return wrap(
    <span className="footer-glow-platform-badge-dot" style={{ backgroundColor: badge.dotColor || '#4ade80' }} />,
    'footer-glow-platform-badge-icon--dot'
  );
}
